export class Device {
  constructor(
      public readonly id: string,
      public readonly name: string,
  ) {
  }
}
